module.exports = __webpack_public_path__ + "img/women-wig-review-3.808aec6f.jpg";